<template>
  <div class="row">
    <div class="col-lg-2 p-0 bg-cx2 d-none d-lg-block">
      <status-menu :statuses="statuses" @select-status="onSelectStatus"></status-menu>
    </div>
    <div class="col-lg-4 p-0 bg-white border-right">
      <orders-list :orders="orders" :selected-status="selectedStatus" @select-order="onSelectOrder">
      </orders-list>
    </div>
    <div class="col-lg-6 p-0 bg-light order-detail d-none d-lg-block">
      <div v-if="loading" class="loading text-muted">
        <h2><i class="fa fa-spinner spin"></i> Loading...</h2>
      </div>
      <order-detail v-else :order="order"></order-detail>
    </div>
  </div>
</template>

<script>
import api from '@/api.js'
import store from '@/stores/inbound.js'
import countBy from 'lodash/countBy'
import StatusMenu from '@/components/inbound/StatusMenu.vue'
import OrdersList from '@/components/inbound/OrdersList.vue'
import OrderDetail from '@/components/inbound/OrderDetail.vue'
import find from 'lodash/find'

export default {

  components: {
    StatusMenu,
    OrdersList,
    OrderDetail
  },
 
  data() {
    return {
      order: {},
      loading: false
    }
  },

  created: function() {
    api.get('/inbound-orders').then(res => {
      store.setOrders(res.data.orders)
    })

    api.get('/inbound-orders/statuses').then(res => {
      store.setStatuses(res.data.statuses)
    })
  },

  mounted() {
    if (this.$route.params.id) {
      this.onSelectOrder(this.$route.params.id)
    }
  },

  watch: {
    '$route.params.id': function (id) {
      this.onSelectOrder(id)
    }
  },

  computed: {
    orders() {
      if (!this.selectedStatus.id || this.selectedStatus.id == 0) {
        return store.state.orders
      }
      return store.state.orders.filter((order) => {
        if(order.status_id == this.selectedStatus.id) {
          return true
        }
      })
    },


    selectedStatus() {
      return find(store.state.statuses, { slug: this.$route.params.status }) || {}
    },

    statuses() {
      const counts = countBy(store.state.orders, 'status_id')
      
      return store.state.statuses.map(status => {
        status.ct = counts[status.id]
        status.active = status.id == this.selectedStatus.id
        return status
      })
    },
  },

  methods: {
    onSelectOrder(id) {
      if (!id) {
        this.order = {}
      } else {
        this.loading = true
        api.get(`/inbound-orders/${id}`).then(res => {
          this.order = res.data.order
          this.loading = false
        })        
      }
    },

    onSelectStatus(status) {
      this.selectedStatus = status
      this.order = {}
    }
  },
}

</script>

<style scoped>
.order-detail {
  height: calc(100vh - 48px);
  overflow-y: auto;
}

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 48px);
}
</style>